<div class="wko-msg-cmp">
  <div [innerHTML]="'components.requestMessageComponent.messages.workload' | translate:param | safeHtml"></div>
</div>
